// services/httpClient.js
import axios from 'axios';
import TokenService from './token.service';

/**
 * Cliente HTTP centralizado con interceptores de autenticación
 * Usa este cliente en lugar de crear instancias de axios en cada service
 */

const AUTH_API_URL = process.env.REACT_APP_AUTH_API_URL || process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

// Cliente HTTP configurado
const httpClient = axios.create({
  baseURL: AUTH_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Request interceptor - añade JWT token automáticamente
httpClient.interceptors.request.use(
  (config) => {
    const token = TokenService.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - maneja errores de autenticación
httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      TokenService.clearTokens();
      // Solo redirigir si estamos en el browser y no es una llamada de validación
      if (typeof window !== 'undefined' && !error.config?.skipAuthRedirect) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

/**
 * Crear un cliente con baseURL diferente
 * @param {string} baseURL - URL base para este cliente
 * @returns {AxiosInstance} Cliente configurado
 */
export const createClient = (baseURL) => {
  const client = axios.create({
    baseURL,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
    }
  });

  // Copiar los mismos interceptores
  client.interceptors.request.use(
    (config) => {
      const token = TokenService.getAccessToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        TokenService.clearTokens();
        if (typeof window !== 'undefined' && !error.config?.skipAuthRedirect) {
          window.location.href = '/login';
        }
      }
      return Promise.reject(error);
    }
  );

  return client;
};

export default httpClient;
